export enum ParentInteractionType {
  PARENTING_ID = 1,
  CANCEl_ID = 2,
}
